import { Link } from '@tanstack/react-router';
import type { FC } from 'react';

const PropertyDetailsPageEmptyState: FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Floor Plan Not Found</h1>
        <p className="text-lg text-gray-600 mb-8">
          The floor plan you&apos;re looking for doesn&apos;t exist or has been removed.
        </p>
        <Link to="/floor-plans" className="btn-primary">
          View All Floor Plans
        </Link>
      </div>
    </div>
  );
};

export default PropertyDetailsPageEmptyState;
